import { Injectable } from "@angular/core";
import { getDownloadURL, getStorage, ref, uploadBytesResumable, uploadString } from "firebase/storage";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FirebaseFileUploadService {
  uploadedPercent$ = new BehaviorSubject(5);
  updateStart$ = new BehaviorSubject(false);
  constructor() {}

  public updateProfileImage(imageToBeUploaded: any, container: string) {
    this.updateStart$.next(true);
    return new Promise((resolve, reject) => {
      const file = imageToBeUploaded.item(0);
      const fileName =
        "FromGallery" +
        new Date().getTime().toString() +
        "." +
        imageToBeUploaded[0]?.name?.split(".")[imageToBeUploaded[0]?.name?.split(".").length - 1];
      const metaData = {
        contentType: "image/jpeg",
      };
      const storage = getStorage();
      const storageRef = ref(storage, container + fileName);

      const uploadTask = uploadBytesResumable(storageRef, file, metaData);

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          this.uploadedPercent$.next((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        },
        (error) => {
          this.updateStart$.next(false);
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref)
            .then((downloadURL) => {
              setTimeout(() => {
                resolve(fileName);
              }, 4000);
            })
            .catch((err) => {
              resolve(fileName);
            })
            .then(() => {
              setTimeout(() => {
                this.updateStart$.next(false);
              }, 4000);
            })
            .catch((error) => {
              return error;
            });
        }
      );
    });
  }

  public updateProfileImageUsingBase64(imageToBeUploaded: any, containerName: string) {
    this.updateStart$.next(true);
    return new Promise((resolve, reject) => {
      const base64 = imageToBeUploaded.base64String; //.split("/")[1];
      const metaData = {
        contentType: "image/jpeg",
      };
      const fileName = "FromCam" + new Date().getTime().toString() + "." + imageToBeUploaded.format;
      const storage = getStorage();

      const storageRef = ref(storage, containerName + fileName);
      const uploadTask = uploadString(storageRef, base64, "base64", metaData);
      uploadTask.then((result) => {
        getDownloadURL(result.ref)
          .then((downloadURL) => {
            // setTimeout(() => {
            resolve(fileName);
            // }, 4000);
          })
          .catch((err) => {
            resolve(fileName);
          })
          .then(() => {
            setTimeout(() => {
              this.updateStart$.next(false);
            }, 4000);
          });
      }).catch((error) => {
        return error;
      });
    });
  }
}
